interface IOneTrustItem {
  id: string;
  link: string;
  replacementPath: string;
}

const defaultMarket = "/us/en";
const privacyNoticePath = '/notices/global-consumer-privacy-notice';
const cookieNoticePath = '/notices/cookie-notice';
const topLevelOneTrustId = 'onetrust-consent-sdk';

const getInitialCurrentMarket = (): string  => {
  const match = window.location.pathname.match(/\/([a-z]{2})\/([a-z]{2})(?:\/|$)/);
    if (match) {
      return `/${match[1]}/${match[2]}`;
    }
    return defaultMarket;
};

const generateLink = (replacementPath: string): string => {
  return `${getInitialCurrentMarket()}${replacementPath}`;
};

const oneTrustItems: IOneTrustItem[] = [
  { 
    id: "onetrust-policy-text",
    link: "a.ot-cookie-policy-link",
    replacementPath: generateLink(privacyNoticePath),
  },
  { 
    id: "ot-pc-desc", 
    link: "a.privacy-notice-link",
    replacementPath: generateLink(privacyNoticePath),
  },
];

const updateOneTrustLink = (): boolean => {
  const isOneTrustPresent =  document.getElementById(topLevelOneTrustId);
  if(!isOneTrustPresent) return false;

  for (const oneTrustItem of oneTrustItems) {
    const oneTrustDescription = document.getElementById(oneTrustItem.id);
    if (!oneTrustDescription) continue;

    const oneTrustLink = oneTrustDescription.querySelector<HTMLAnchorElement>(oneTrustItem.link);
    if (!oneTrustLink) continue;
    oneTrustLink.href = oneTrustItem.replacementPath;
  }
  return true;
}

const observeOneTrustBanner = (): void => {
  if (updateOneTrustLink()) return;
  const maxAttempts = 5;
  let attempts = 0;

  const mutationObserver = new MutationObserver(
    (_, observerInstance) => {
      attempts++;
      if (attempts >= maxAttempts) {
        observerInstance.disconnect();
        return;
      }

      const updatedSuccessfully = updateOneTrustLink();

      if (updatedSuccessfully) {
        observerInstance.disconnect();
      }
    }
  );

  mutationObserver.observe(document.body, {
    childList: true,
    subtree: true,
  });
}

if (document.readyState !== "loading") {
  observeOneTrustBanner();
} else {
  document.addEventListener("DOMContentLoaded", observeOneTrustBanner);
}
